<div class="box topicListView" *ngIf="RoomTopicList != ''">

  <table class="table is-responsive is-striped is-fullwidth">
    <thead>
      <tr class="is-vcentered">
        <th></th>
        <th>Topic / Assignment</th>
        <th>Session (or) Submission Date & Time</th>
        <th>Types</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody *ngFor="let item of RoomTopicList; let i=index">
        <tr [ngClass]="{'is-info': topicHighlight == item.topic}">
          <td (click)="toggle(item, item.topic_id)" >
            <figure class="has-text-centered" *ngIf="item.staff_type!='T' && item.is_published">
              <a class="button is-small " data-tooltip="Expend or Collapse" >
                <i class="fa " [ngClass]="{'fa-angle-down': !showAssignTable[item.topic_id], 'fa-angle-up': showAssignTable[item.topic_id]}" ></i>
              </a>
            </figure>
          </td>
          <td class="list-ellipsis" style="text-transform: capitalize;">{{item.topic}}</td>
          <td>{{item.shedule_date | date:'MMM d, y '}} {{item.shedule_time }}</td>
          <td>
            <div *ngIf="item.staff_type=='T'; else elseTemplate">
              Topic
            </div>
            <ng-template #elseTemplate>
              Assignment
            </ng-template>
          </td>

          <!-- <td>{{item.created_at | date: 'dd MMM yyyy'}}</td> -->
          <td>
            <div class="actionBtnDeskView">
              <a class="button is-small has-tooltip-top" data-tooltip="View Topic/Assignment" (click)="viewCurrentTopic(item.topic_id)">
                <i class="fa fa-eye" aria-hidden="true"></i>
              </a>
              <span class="button is-small has-tooltip-left"  [ngClass]="{'isPublished': item.is_published}" *ngIf="item.is_published; else elseEdit">
                <i class="fa fa-pencil is-small" aria-hidden="true"></i>
              </span>
              <ng-template #elseEdit>
                <a class="button is-small has-tooltip-top" [ngClass]="{'isPublished': item.is_published}" data-tooltip="Edit Topic/Assignment" (click)="editTopicData(item.topic_id)">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </a>
              </ng-template>
              <span class="button is-small has-tooltip-left"  [ngClass]="{'isPublished': item.is_published}" *ngIf="item.is_published; else elsePublish" data-tooltip="This topic/assignment has been published to user">
                <i class="fa fa-paper-plane is-small" aria-hidden="true"></i>
              </span>
              <ng-template #elsePublish>
                <a class="button is-small has-tooltip-left" (click)="IsPublishedTopic(classRoomId, item.topic_id)" data-tooltip="Clicking this button will publish this topic/assignment to user" >
                  <i class="fa fa-paper-plane is-small" aria-hidden="true"></i>
                </a>
              </ng-template>
              <a class="dropdown button is-small has-tooltip-top is-right" [ngClass]="{'is-active': isDropHoverable[item.topic_id]}" data-tooltip="Click More" aria-haspopup="true" aria-controls="dropdown-menu" (mouseenter)="showMoreBtnOption(item.topic_id)" (mouseleave)="hideMoreBtnOption(item.topic_id)">
                <div class="dropdown-trigger">
                  <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                </div>
                <div class="dropdown-menu" id="dropdown-menu" role="menu">
                  <div class="dropdown-content">
                    <span *ngIf="item.file_type === 'video' || item.file_type === 'audio' ; else tileViewTemplate">
                      <a class="dropdown-item is-small has-tooltip-top" (click)="playMedia(item)" *ngIf="item.file_path!= null">
                        <i class="fa fa-play is-small" aria-hidden="true"></i> Play
                      </a>
                    </span>
                    <ng-template #tileViewTemplate>
                      <a class="dropdown-item is-small has-tooltip-top" (click)="secureFileDownLoad(item)" *ngIf="item.file_path!= null">
                        <i class="fa fa-download is-small" aria-hidden="true"></i> Download
                      </a>
                    </ng-template>
                    <hr class="dropdown-divider">
                    <a class="dropdown-item is-small has-tooltip-top" (click)="deletedTopic(item.topic_id)" >
                      <i class="fa fa-trash" aria-hidden="true"></i> Delete
                    </a>
                  </div>
                </div>
              </a>
            </div>
            <div class="actionBtnMobileView">
              <a class="button is-small has-tooltip-top" data-tooltip="View Topic/Assignment" (click)="viewCurrentTopic(item.topic_id)">
                <i class="fa fa-eye" aria-hidden="true"></i>
              </a>
              <span class="button is-small has-tooltip-left"  [ngClass]="{'isPublished': item.is_published}" *ngIf="item.is_published; else elsePublish" data-tooltip="This topic/assignment has been published to user">
                <i class="fa fa-paper-plane is-small" aria-hidden="true"></i>
              </span>
              <ng-template #elsePublish>
                <a class="button is-small has-tooltip-left" (click)="IsPublishedTopic(classRoomId, item.topic_id)" data-tooltip="Clicking this button will publish this topic/assignment to user" >
                  <i class="fa fa-paper-plane is-small" aria-hidden="true"></i>
                </a>
              </ng-template>
              <a class="dropdown button is-small has-tooltip-top is-right" [ngClass]="{'is-active': isDropHoverable[item.topic_id]}" data-tooltip="Click More" aria-haspopup="true" aria-controls="dropdown-menu" (mouseenter)="showMoreBtnOption(item.topic_id)" (mouseleave)="hideMoreBtnOption(item.topic_id)">
                <div class="dropdown-trigger">
                  <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                </div>

                <div class="dropdown-menu" id="dropdown-menu" role="menu">
                  <div class="dropdown-content">
                    <a class="dropdown-item is-small has-tooltip-left" [ngClass]="{'isPublished': item.is_published}" data-tooltip="Edit Topic/Assignment" (click)="editTopicData(item.topic_id)">
                      <i class="fa fa-pencil" aria-hidden="true"></i> Edit
                    </a>
                    <span *ngIf="item.file_type === 'video' || item.file_type === 'audio' ; else tileViewTemplate">
                      <a class="dropdown-item is-small has-tooltip-top" (click)="playMedia(item)" *ngIf="item.file_path!= null">
                        <i class="fa fa-play is-small" aria-hidden="true"></i> Play
                      </a>
                    </span>
                    <ng-template #tileViewTemplate>
                      <a class="dropdown-item is-small has-tooltip-top" (click)="secureFileDownLoad(item)" *ngIf="item.file_path!= null">
                        <i class="fa fa-download is-small" aria-hidden="true"></i> Download
                      </a>
                    </ng-template>
                    <hr class="dropdown-divider">
                    <a class="dropdown-item is-small has-tooltip-top" (click)="deletedTopic(item.topic_id)" >
                      <i class="fa fa-trash" aria-hidden="true"></i> Delete
                    </a>
                  </div>
                </div>
              </a>
            </div>
        </td>
        </tr>
        <tr class="d-none row-num-{{item.topic_id}}" >

          <td *ngIf="showAssignTable[item.topic_id]" colspan="6">
            <div class="row">
              <table class="table is-responsive is-striped is-fullwidth is-capitalized" style="width: 100%;">
                <thead>
                  <tr>
                    <th>Assigned To</th>
                    <th>Status</th>
                    <th>Submission Date & Time</th>
                    <th>FeedBack</th>
                    <th>Assignment Mark</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of getUserList">
                    <td>{{user.assigned_to}}</td>
                    <td>
                      <span *ngIf="user.is_submit===false; else elseTemplate">
                        Assigned
                      </span>
                      <ng-template #elseTemplate>
                        Completed
                      </ng-template>
                    </td>
                    <td>{{user.created_at | date:'MMM d, y' }}</td>
                    <td>{{user.feedback}}</td>
                    <td>{{user.marks}}</td>
                    <td *ngIf="user.is_submit===true">
                      <a class="button is-small has-tooltip-left" data-tooltip="View Assignment" (click)="readSecureFileAssign(user, item.topic_id)">
                        <i class="fa fa-file" aria-hidden="true"></i>
                      </a>
                      <a class="button is-small has-tooltip-left" data-tooltip="Download Assignment" (click)="secureFileDownLoad(user)">
                        <i class="fa fa-download" aria-hidden="true"></i>
                      </a>
                      <span class="feebackDetails" *ngIf="user.is_feedback; else elsFeedback">
                        <a class="feedSub button is-small" data-tooltip="FeedBack Submitted" style="background-color: forestgreen; color: #fff;" (click)="showPublishFeedback(item.topic_id, user.student_id)">
                          <i class="fa fa-rss" aria-hidden="true"></i>
                        </a>
                      </span>
                      <ng-template #elsFeedback>
                        <a class="button is-small has-tooltip-left" (click)="isPublishFeedback(user, item.topic_id)" data-tooltip="FeedBack">
                          <i class="fa fa-rss" aria-hidden="true"></i>
                        </a>
                      </ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
    </tbody>
  </table>
</div>


<div class="showAssignment" (click)="onClickModalOutSide(topicId)">

  <div class="modal" [ngClass]="{'is-modal-active': viewAssignment[topicId]}" style="border: 3px solid #fff;">
    <div class="modal-background"></div>
    <div class="modal-content">
      <span class="is-loading" *ngIf="showFileLoadSpinner" style="position: absolute; top:35%; left: 43%;">
        <img src="../../../../../../assets/images/loader-dot-small.gif" alt="">
      </span>


      <div *ngIf="viewFileType==='image'; else elseDocTemplate">
        <img class="thumb_img" src="{{doc}}" />
      </div>
      <ng-template #elseDocTemplate>
        <ngx-doc-viewer url="{{doc}}" viewer="google" googleCheckContentLoaded="true"
        googleCheckInterval="3000"
        googleMaxChecks="5" style="width:100%;height:600px;z-index: 999">
        </ngx-doc-viewer>
      </ng-template>
    </div>
    <button class="modal-close is-large" aria-label="close" (click)="hideAssignModal(topicId)" style="right: 90px !important;"></button>
  </div>

  <div class="modal" [ngClass]="{'is-modal-active': isviewUploadDoc}">
    <div class="modal-background"></div>
    <div class="modal-content" style="width: 100%; height: auto;">
      <ngx-doc-viewer queryParams="h1=N1" viewer="google" googleCheckContentLoaded="true"
      googleCheckInterval="3000"
      googleMaxChecks="5" [url]="selectedDoc" style="width:100%; height: 100vh;"></ngx-doc-viewer>
      <!-- <iframe width="100%" height="auto" frameBorder="0" [src]="selectedDoc"></iframe> -->
    </div>
    <button class="modal-close is-large" aria-label="close" (click)="hideModalWindow()"></button>
  </div>

  <!--Feed Back for Assignment-->
  <div class="modal" [ngClass]="{'is-modal-active': isactiveFeedback[topicId]}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <div class="card">
      <form [formGroup]="feedbackForm">
        <div class="card-header">
          <p class="card-header-title">Assignment Feedback</p>
          <button class="delete" aria-label="close" (click)="hideFeedbackModal(topicId)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">Assignment Feedback</label>
                  <div class="control">
                    <textarea class="textarea" placeholder="Message" rows="1" formControlName="feedback" maxlength="255"></textarea>
                    <p class="help is-danger" *ngIf="feedbackForm.controls.feedback">Message length must be less than 255 characters</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="field">
              <label for="" class="label">Assignment Mark (100%)</label>
              <div class="control">
                <input type="text" class="input" name="assign_marks" placeholder="Assignment Marks" formControlName="marks" (keypress)="onClickFeedbackMark($event)">
              </div>
            </div>
          </div>
        </div>
        <footer class="modal-card-foot">
          <div class="column is-12 has-text-right is-small">
            <button class="button mar-0-5 is-small" (click)="hideFeedbackModal(topicId)">Cancel</button>
          <button class="button is-link is-small" (click)="submitFeedback(feedbackForm.value, feebackData, topicId)" [disabled]="!feedbackForm.valid" *ngIf="!showBtnSpinner">Save FeedBack</button>
          <a class="button is-link is-loading is-small" style="min-width: 100px;"  *ngIf="showBtnSpinner"></a>
          </div>
        </footer>
      </form>
      </div>
    </div>
  </div>

  <!--View Current Topic-->
  <div class="modal" [ngClass]="{'is-modal-active': isViewTopic[viewTopicId]}">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 850px;">
      <div class="card">
        <div class="card-header">
          <p class="card-header-title">View Topic/Assignment</p>
          <button class="delete" aria-label="Close" (click)="hideTopicModal(viewTopicId)"></button>
        </div>
        <div class="card-content">
          <div class="content is-capitalized">
            <div class="columns">
              <div class="column is-5">
                <div class="field">
                  <label for="" class="label">Title</label>
                  <span>{{getTopicDetails['topic']}}</span>
                </div>
                <div class="field">
                  <label for="" class="label">{{getTopicDetails['staff_type']=='T'? 'Session' : 'Submission'}} Date & Time</label>
                  <span>{{getTopicDetails['shedule_date'] | date:'MMM d, y'}} {{getTopicDetails['shedule_time']}}</span>
                </div>
                <div class="field">
                  <label for="" class="label">Type</label>
                  <span>{{getTopicDetails['staff_type']=='T'? 'Topic' : 'Assignment'}}</span>
                </div>
                <div class="field">
                  <label for="" class="label">Description</label>
                  <span [innerHTML]="getTopicDetails['notes']"></span>
                </div>
              </div>
              <div class="column is-7">
                <div *ngIf="getTopicDetails['file_id']==null; else elseAttTemplate">
                  <div class="field" >
                    <label for="" class="label">Attach File</label>
                    <span class="has-text-grey-lighter">There is no attach file here..</span>
                  </div>
                </div>
                <ng-template #elseAttTemplate>
                  <div class="field" >
                    <label for="" class="label">Attach File</label>
                    <div *ngIf="getTopicDetails['file_type']==='video' || getTopicDetails['file_type']==='audio'; else elseMediaTemplate">
                      <div *ngIf="getTopicDetails['file_type']==='video'; else elseAudioTemplate">
                        <vg-player
                        style="height: 332px"
                        (onPlayerReady)="videoPlayerInit($event)"
                      >
                        <vg-overlay-play></vg-overlay-play>
                        <vg-buffering></vg-buffering>

                        <vg-scrub-bar>
                          <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                          <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                        </vg-scrub-bar>

                        <vg-controls [vgAutohide]="true" [vgAutohideTime]="2">
                          <vg-play-pause></vg-play-pause>
                          <!-- <vg-time-display
                            vgProperty="current"
                            vgFormat="mm:ss"
                          ></vg-time-display> -->

                          <vg-scrub-bar
                            style="pointer-events: none"
                          ></vg-scrub-bar>
                          <vg-mute></vg-mute>
                          <vg-volume></vg-volume>

                          <vg-fullscreen></vg-fullscreen>
                        </vg-controls>

                        <video
                          #media
                          [vgMedia]="media"
                          id="singleVideo"
                          crossorigin
                        >
                          <source [src]="inputSrc" type="video/mp4" />
                        </video>
                      </vg-player>
                      </div>
                      <ng-template #elseAudioTemplate>
                        <vg-player
                        style="height: 332px"
                        (onPlayerReady)="videoPlayerInit($event)"
                      >
                        <vg-overlay-play></vg-overlay-play>
                        <vg-buffering></vg-buffering>

                        <vg-controls>
                          <vg-play-pause></vg-play-pause>
                          <!-- <vg-time-display
                            vgProperty="current"
                            vgFormat="mm:ss"
                          ></vg-time-display> -->

                          <vg-scrub-bar>
                            <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                            <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                          </vg-scrub-bar>

                          <!-- <vg-time-display
                            vgProperty="total"
                            vgFormat="mm:ss"
                          ></vg-time-display> -->

                          <vg-mute></vg-mute>

                        </vg-controls>

                        <audio
                          #audio
                          [vgMedia]="audio"
                          id="myAudio"
                          preload="none"
                        >
                          <source [src]="inputSrc" [type]="'audio/mpeg'" />
                        </audio>
                      </vg-player>
                      </ng-template>
                    </div>
                    <ng-template #elseMediaTemplate>
                      <div class="" *ngIf="getTopicDetails['file_type']==='image'; else elseImgTemplate">
                        <img
                          class="thumb_img" style="height: 332px;"
                          [src]="getTopicDetails['view_url']"
                        />
                      </div>
                      <ng-template #elseImgTemplate>
                        <span
                            class="is-loading"
                            *ngIf="showFileLoadSpinner"
                            style="position: absolute; top: 35%; left: 43%"
                          >
                            <img
                              src="../../../../../../assets/images/loader-dot-small.gif"
                              alt=""
                            />
                          </span>
                        <ngx-doc-viewer
                            url="{{ selectedReadFile }}"
                            viewer="google"
                            style="width: 100%; height: 600px; z-index: 999"
                          >
                          </ngx-doc-viewer>
                      </ng-template>
                    </ng-template>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Edit Topic Records-->
  <div class="modal scroll-bar" [ngClass]="{'is-modal-active':editTopicActive[topicId]}" >
    <div class="modal-background"></div>
    <div class="modal-card" >
      <div class="card">
        <form [formGroup]="editTopicForm" novalidate>
          <div class="card-header">
            <p class="card-header-title">Edit Topic / Assignment</p>
            <button class="delete" aria-label="close" (click)="hideEditModal(topicId)"></button>
          </div>
          <div class="card-content scroll-bar pos-relative">
            <div class="content">
              <div class="column is-12">
                <div class ="columns">
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">Title</label>
                      <div class="control">
                        <input type="text" name="topic" class="input" [(ngModel)]="topicData['topic']" placeholder="Topic Heading here..." formControlName="topic">
                      <form-validation [control]="editTopicForm.controls.topic"></form-validation>
                      </div>
                    </div>
                  </div>
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">Type</label>
                      <div class="control">
                        <label class="radio"   *ngFor="let type of staffType">
                          <input type="radio" name="staff_type" formControlName="staff_type" value="{{type.value}}" [checked]="topicData['staff_type']==type.value" [(ngModel)]="topicData['staff_type']">
                          {{type.name}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns ">
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">{{topicData['staff_type']=='T' ? 'Session' : 'Submission'}} Date</label>
                      <input type="date" id="datepickerDemo" name="shedule_date" class="input" [min]="getToday()"  formControlName="shedule_date" (keydown)="false" [(ngModel)]="topicData['shedule_date']">

                    </div>
                  </div>
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">{{topicData['staff_type']=='T' ? 'Session' : 'Submission'}} Time</label>
                      <!-- <input type="time" name="shedule_time" class="input" [min]="getCurrentTime()"  formControlName="shedule_time" (keydown)="false" [(ngModel)]="topicData['shedule_time']"> -->
                      <input [ngxTimepicker]="picker" class="input" name="shedule_time" formControlName="shedule_time" [value]="editTopicTime">
                      <ngx-material-timepicker #picker ></ngx-material-timepicker>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <div class="field post-attach-file">
                      <label class="label" data-tooltip="Attach only PNG,JPEG,JPG,MP3,MP4,WAV,PDF,PPT,PPTX,PPTM,XML,XLS,XLSX,DOC,DOCX,TXT file">Attach File
                        <i class="fa fa-info-circle is-size-6" aria-hidden="true"></i>
                      </label>
                      <div class="control file is-boxed is-fullwidth is-info-light" *ngIf="!preUploadedFile">
                        <label class="file-label">
                          <input type="file" name="msg-file" style="display:none" (change)="onFileChange($event)" #topicFileInput accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .pptm, .xml, .xls, .xlsx, .doc, .docx, .txt">
                          <span class="file-cta">
                            <span class="file-icon">
                              <i class="fa fa-upload"></i>
                            </span>
                            <span class="file-label is-small is-centered">
                              Attach file here…
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>
                    <div *ngIf="upLoadedFileList.length > 0">
                      <div class="pos-relative" *ngFor="let eachFile of upLoadedFileList">
                        <div class="file-detail">
                          <div class="content-align">
                            <p>
                              <!--<img  src="../../../../assets/images/file_types/{{eachFile.mimeType}}.png" width="35px" height="35px">--> {{eachFile.name}}</p>
                            <span class="file-size is-small">{{eachFile.size | fileSize}}</span>
                            <progress class="progress is-link is-small" value="{{eachFile.progressVal}}" max="100" *ngIf="eachFile.progressVal"></progress>
                          </div>
                        </div>
                        <!-- <i class="fa fa-times" aria-hidden="true" (click)="removeFileFromList(eachFile)"></i> -->
                      </div>
                    </div>
                    <div class="is-small" *ngIf="preUploadedFile && uploadAttachFile; else elseTemplate">
                      <div *ngFor="let f of uploadFileIcons">
                        <span *ngIf="f.name===preUploadedFile.file_ext">
                          <img [src]="f.icons" alt="" width="35px" height="35px">{{preUploadedFile.file_id}}

                          <button class="delete" aria-label="Delete" (click)="removeUploadFile(upLoadedFileList)"></button>
                        </span>
                      </div>
                    </div>
                    <ng-template #elseTemplate>
                      <div *ngFor="let f of uploadFileIcons">
                        <div *ngIf="uploadAttachFile && upLoadedFileList.length===0">
                          <span *ngIf="f.name===topicData['file_ext']">
                            <img [src]="f.icons" alt="" width="35px" height="35px"> {{topicData['file_id']}}
                            <button class="delete" aria-label="Delete" (click)="removeExitingFile(topicData['file_id'])"></button>
                          </span>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
                <div class="field">
                  <label class="label">Description</label>
                  <angular-editor class="scroll-bar" formControlName="notes" [(ngModel)]="topicData['notes']" [config]="editorConfig" cols="10" rows="2" maxlength="500"></angular-editor>
                  <p class="help is-danger" *ngIf="editTopicForm.controls.notes">Message length must be less than 500 characters</p>
                </div>
              </div>
            </div>
          </div>
          <footer class="modal-card-foot">
            <div class="column is-12 has-text-right is-small">
            <button class="button is-small" [disabled]="upLoadedFileList.length > 0" (click)="hideEditModal(topicId)">Cancel</button>
            <button class="button is-link is-small disabledBtn" [disabled]="(editTopicForm.valid && !editTopicForm.dirty) || editTopicForm.invalid" (click)="updateTopicDetails(editTopicForm.value, topicId)" *ngIf="!showBtnSpinner">Update</button>
            <a class="button is-link is-loading is-small" style="min-width: 100px;"  *ngIf="showBtnSpinner"></a>
            </div>
          </footer>
        </form>
      </div>
    </div>
  </div>


  <div class="common-empty topic-notify box" *ngIf="RoomTopicList.length===0">
    <article class="media">
      <div class="media-content has-text-centered">
        <!-- <img [src]="'../../../../assets/images/notification_empty.svg'"> -->
        <p>No Topic/Assignment List found. Please click above button to create a Topic or Assignment</p>
      </div>
    </article>
  </div>
</div>
